import { FormItem } from '@/components/Form/FormGroup';
import InputRadio from '@/components/Input/InputRadio';
import { PAYTYPE_PAYMENT_DAY_LIST } from '@/helpers/PaymentHelper';
import React, { InputHTMLAttributes, forwardRef } from 'react';
import styled from 'styled-components';

export const LabelFlex = styled.ul`
  display: flex;
  justify-content: space-between;
  &.donate {
    align-items: flex-start;
    margin-top: 22px;
  }
`;

export const DonateFormItem = styled(FormItem)`
  padding-top: 24px;
  padding-bottom: 40px;
`;

interface InputRadioPledgePaymentDayProps
  extends InputHTMLAttributes<HTMLInputElement> {
  paytype: string;
  defaultDay?: string;
  name: string;
  className?: string;
  readony?: boolean;
}
export const InputRadioPledgePaymentDay = forwardRef<
  HTMLInputElement,
  InputRadioPledgePaymentDayProps
>(({ paytype, defaultDay, name, className, readOnly, ...props }, ref) => (
  <LabelFlex className={className}>
    {PAYTYPE_PAYMENT_DAY_LIST[paytype].map((paymentDay: any) => (
      <li key={`payday_${paymentDay.day}`}>
        {' '}
        <InputRadio
          {...props}
          name="paymentDay"
          ref={ref}
          value={paymentDay.day}
          label={`${paymentDay.dayKo || paymentDay.day}일`}
          defaultChecked={defaultDay === paymentDay.day}
          readOnly={readOnly}
          bg="white"
        />
      </li>
    ))}
  </LabelFlex>
));
